export default __webpack_public_path__ + "static/media/training.951c76da.svg";